import { CONTENT } from "@/content";
import { Reveal } from "../ui/Reveal";
import { SecHead } from "./SecHead";
import { CompassInteractive } from "./CompassInteractive";

export function Metodo() {
  const m = CONTENT.metodo;
  return (
    <section className="section dark metodo" id="metodo">
      <div className="wrap">
        <SecHead label={m.label} title={m.title} intro={m.intro} dark align="split" />

        <div className="compass">
          <Reveal className="compass-label">
            <span className="compass-sub">{m.pillarsTitle}</span>
          </Reveal>
          <Reveal delay={1}>
            <CompassInteractive pillars={m.pillars} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
